import { captureSetupTokenFromUrl } from './passwordSetupLink';

captureSetupTokenFromUrl();
